import { useQuery } from "@tanstack/react-query";
import { adminPaymentGatewayEventService } from "@/services/admin-payment-gateway-event.service";
import type { PaymentGatewayEventListFilters } from "@/types/payment-gateway-event";

export const paymentGatewayEventKeys = {
  all: ["payment-gateway-events"] as const,
  lists: () => [...paymentGatewayEventKeys.all, "list"] as const,
  list: (filters: PaymentGatewayEventListFilters) =>
    [...paymentGatewayEventKeys.lists(), filters] as const,
};

export function usePaymentGatewayEvents(
  filters: PaymentGatewayEventListFilters,
) {
  return useQuery({
    queryKey: paymentGatewayEventKeys.list(filters),
    queryFn: () =>
      adminPaymentGatewayEventService.getPaymentGatewayEvents(filters),
    staleTime: 10000, // 10 seconds

    // Keep the rows on screen while the next page or search loads.
    placeholderData: (previousData) => previousData,
  });
}
